import { render, staticRenderFns } from "./HelpArticle.vue?vue&type=template&id=3fdc2664&"
import script from "./HelpArticle.vue?vue&type=script&lang=js&"
export * from "./HelpArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports